import DeleteHash from './DeleteHash';

export default DeleteHash;
